import React, { useEffect, useState } from 'react';
import { readDoctors } from './fontStyle';
import './ReportLayout.css';

// Doctor records from Template Settings, shown above the report footer.
// Templates place it inside a .report-page-bottom group (see ReportLayout.css).
// Renders nothing when no doctor is configured.
const DoctorInfo = ({ fontFamily, accentColor = '#0284c7' }) => {
  const [drs, setDrs] = useState([]);

  useEffect(() => {
    setDrs(readDoctors());
  }, []);

  if (drs.length === 0) return null;

  return (
    <div
      className="report-doctor-info"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${Math.min(drs.length, 3)}, 1fr)`,
        gap: '16px',
        margin: '16px 0',
        textAlign: 'center',
        fontFamily,
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
      }}
    >
      {drs.map((doc, idx) => (
        <div key={doc.drid || idx} style={{ padding: '8px', borderTop: '1px dashed #cbd5e1' }}>
          <div style={{ fontWeight: '700', fontSize: '12px', color: '#0f172a' }}>{doc.drname}</div>
          {doc.designation && (
            <div style={{ color: accentColor, fontSize: '10px', fontWeight: '500' }}>{doc.designation}</div>
          )}
          {doc.description && (
            <div style={{ color: '#64748b', fontSize: '10px', whiteSpace: 'pre-line' }}>{doc.description}</div>
          )}
          {doc.address && (
            <div style={{ color: '#64748b', fontSize: '10px' }}>{doc.address}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default DoctorInfo;
